import { Button } from "antd";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

import classes from "./PrivacyConsent.css";
import { withNamespaces } from "react-i18next";

const COOKIE_NAME = "consentAccepted";

const getConsentCookie = () => Cookies.get(COOKIE_NAME);

const hasConsentCookie = () => !!getConsentCookie();

const setConsentCookie = () => Cookies.set(COOKIE_NAME, true, { expires: 365 });

const PrivacyConsent = (props) => {
  const [accepted, setAccepted] = useState(hasConsentCookie());

  useEffect(() => {
    if (accepted) {
      setConsentCookie();
    }
  }, [accepted]);

  if (accepted) {
    return null;
  }

  return (
    <div className={classes.privacyConsent}>
      <div>
        {props.i18n.t('NamespacePrivacyConsent:DCTMS is using cookies to ensure a satisfying experience.')}{" "}
        <a href="/privacy-policy">{props.i18n.t('NamespacePrivacyConsent:More Information')}</a>.
      </div>
      <div>
        <Button type="primary" onClick={() => setAccepted(true)}>
          {props.i18n.t('Accept')}
        </Button>
      </div>
    </div>
  );
};

export default withNamespaces()(PrivacyConsent);



// WEBPACK FOOTER //
// ./src/components/PrivacyConsent/PrivacyConsent.js